'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _themeProductForm = require('@shopify/theme-product-form');

var _themeCurrency = require('@shopify/theme-currency');

var _themeSections = require('@shopify/theme-sections');

var _themeA11y = require('@shopify/theme-a11y');

var _photoswipe = require('photoswipe');

var _photoswipe2 = _interopRequireDefault(_photoswipe);

var _photoswipeUiDefault = require('photoswipe/dist/photoswipe-ui-default');

var _photoswipeUiDefault2 = _interopRequireDefault(_photoswipeUiDefault);

var _lodashEs = require('lodash-es');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Init empty gallery array
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */
var container = [];

// Loop over gallery items and push it to the array
(0, _jquery2.default)('.product-slider__inner').find('.product-slider__item__image').each(function () {
  var $link = (0, _jquery2.default)(this).find('a'),
      item = {
    src: $link.attr('href'),
    w: $link.data('width'),
    h: $link.data('height'),
    title: $link.data('caption')
  };
  container.push(item);
});

(0, _jquery2.default)('.product-slider__item a').click(function (event) {
  var indexOfSlide = (0, _jquery2.default)(this).closest('.product-slider__item').data('index') - 1;

  // Prevent location change
  event.preventDefault();

  // Define object and gallery options
  var $pswp = (0, _jquery2.default)('.pswp')[0],
      options = {
    index: indexOfSlide,
    bgOpacity: 0.85,
    showHideOpacity: true
  };

  // Initialize PhotoSwipe
  var gallery = new _photoswipe2.default($pswp, _photoswipeUiDefault2.default, container, options);
  console.log(container);
  gallery.init();
});

// if(boostPFSAppConfig){
//   const swatches = document.querySelectorAll(".product-detail__color");
//   swatches.forEach(swatch => {
//     console.log(swatch);
//     const swatchName = swatch.dataset.color;
//     swatch.classList.add('swatch');
//     if (boostPFSAppConfig.swatch_settings) {

//       const hexCode = boostPFSAppConfig.swatch_settings[swatchName].colorCodes[0];
//       if(hexCode){
//         swatch.querySelector('span').style.backgroundColor = hexCode;
//       }
//     } 
// 	});
// }

function centerModal() {
  var modal = (0, _jquery2.default)('.modal.open');
  var mWidth = modal.outerWidth();
  var mHeight = modal.outerHeight();
  var width = (0, _jquery2.default)(window).width();
  var height = (0, _jquery2.default)(window).height();
  if (width % 1 != 0) {
    width = Math.round(width);
  }
  if (height % 1 != 0) {
    height = Math.round(height);
  }
  var topPos = height / 2 - mHeight / 2 + 90;
  var leftPos = width / 2 - mWidth / 2;
  modal.css({ top: topPos, left: leftPos });
}

(0, _jquery2.default)('body').on('click', '.product-detail__measuretable', function (e) {
  e.preventDefault();
  var handle = (0, _jquery2.default)(this).data('handle');
  _jquery2.default.getJSON(handle, function (page) {
    var pageTitle = page.page.title;
    var pageContent = page.page.body_html;
    var modalTitle = document.querySelector('.info-modal .title');
    var modalContent = document.querySelector('.info-modal .content');
    modalTitle.innerHTML = pageTitle;
    modalContent.innerHTML = page.page.body_html;
    (0, _jquery2.default)('.info-modal').addClass('active');
  });
});

(0, _jquery2.default)('body').on('click', '.info-modal-bg, .info-modal-close', function (e) {
  (0, _jquery2.default)('.info-modal').removeClass('active');
});

//open modal and overlay
function openModal() {
  (0, _jquery2.default)('.modal').removeClass('hidden').addClass('open');
  (0, _jquery2.default)('.modal--overlay').removeClass('hidden').addClass('open');
  (0, _jquery2.default)('body').css('overflow', 'hidden');
  centerModal();
}

//close modal and overlay
function closeModal(overlay) {
  (0, _jquery2.default)(overlay).addClass('hidden').removeClass('open');
  (0, _jquery2.default)('.modal.open').addClass('hidden').removeClass('open');
  (0, _jquery2.default)('body').css('overflow', 'auto');
}

(0, _jquery2.default)('body').on('click', '.modal .close', function () {
  var overlay = (0, _jquery2.default)('.modal--overlay');
  closeModal(overlay);
});

var cartCount = (0, _jquery2.default)('#cart-number span').html();

function addToCartOk(product) {
  cartCount++;
  var product = product.items[0];
  console.log(product);
  (0, _jquery2.default)('.modal .product .modal-product-image').html('<img src="' + product.featured_image.url + ' "/>');
  (0, _jquery2.default)('.modal .product .modal-product-info').html('\n   <div class="modal-product-info-title">' + product.product_title + '</div>\n   <div class="modal-product-info-size"></div>\n   <div class="modal-product-info-price">' + (0, _themeCurrency.formatMoney)(product.final_price, theme.moneyFormat) + '</div>\n   ');
  var options = product.options_with_values;
  _jquery2.default.each(options, function (i, option) {
    (0, _jquery2.default)('.modal-product-info-size').append(option.name + ': ' + option.value);
  });
  (0, _jquery2.default)('#cart-number').data('count', cartCount);
  (0, _jquery2.default)('#cart-number span').html(cartCount);
  openModal();
}

function addToCartFail(obj, status) {
  (0, _jquery2.default)('.modal').html('<div class="header unavailable">Product is niet beschikbaar.</div>');
  openModal();
}

(0, _jquery2.default)('.modal--overlay').on('click', function () {
  var overlay = (0, _jquery2.default)('.modal--overlay');
  closeModal(overlay);
});

var labels = document.querySelectorAll('.shopify-product-form .product-options label');
if (labels) {
  labels.forEach(function (label) {

    var width = label.offsetWidth;
    console.log(width);
    label.style.width = width + 'px';
  });
}

var classes = {
  hide: 'hide'
};

var keyboardKeys = {
  ENTER: 13
};

var selectors = {
  submitButton: '[data-submit-button]',
  submitButtonText: '[data-submit-button-text]',
  comparePrice: '[data-compare-price]',
  comparePriceText: '[data-compare-text]',
  priceWrapper: '[data-price-wrapper]',
  imageWrapper: '[data-product-image-wrapper]',
  visibleImageWrapper: '[data-product-image-wrapper]:not(.' + classes.hide + ')',
  imageWrapperById: function imageWrapperById(id) {
    return selectors.imageWrapper + '[data-image-id=\'' + id + '\']';
  },
  productForm: '[data-product-form]',
  productPrice: '[data-product-price]',
  thumbnail: '[data-product-single-thumbnail]',
  thumbnailById: function thumbnailById(id) {
    return '[data-thumbnail-id=\'' + id + '\']';
  },
  thumbnailActive: '[data-product-single-thumbnail][aria-current]'
};

(0, _themeSections.register)('part-related-products', {
  onLoad: function onLoad() {
    var _this = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.ProductRecommendations('[data-recommendations]');

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  ProductRecommendations: function ProductRecommendations(container) {

    var $container = this.$container = (0, _jquery2.default)(container);
    var baseUrl = $container.data('baseUrl');
    var productId = $container.data('productId');
    var limit = $container.data('limit');
    var productRecommendationsUrlAndContainerClass = baseUrl + '?section_id=part-related-products&limit=' + limit + '&product_id=' + productId + ' .product-recommendations';
    $container.parent().load(productRecommendationsUrlAndContainerClass);
  }
});

(0, _themeSections.register)('product', {
  onLoad: function onLoad() {
    var _this2 = this;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var productFormElement;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              productFormElement = document.querySelector(selectors.productForm);
              _context2.next = 3;
              return _this2.getProductJson(productFormElement.dataset.productHandle);

            case 3:
              _this2.product = _context2.sent;

              _this2.productForm = new _themeProductForm.ProductForm(productFormElement, _this2.product, {
                onOptionChange: _this2.onFormOptionChange.bind(_this2),
                onFormSubmit: _this2.onFormSubmit.bind(_this2)
              });

              _this2.onThumbnailClick = _this2.onThumbnailClick.bind(_this2);
              _this2.onThumbnailKeyup = _this2.onThumbnailKeyup.bind(_this2);

              _this2.container.addEventListener('click', _this2.onThumbnailClick);
              _this2.container.addEventListener('keyup', _this2.onThumbnailKeyup);

            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  onFormSubmit: function onFormSubmit(event) {
    event.preventDefault();

    _jquery2.default.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        items: [{
          id: event.dataset.variant.id,
          quantity: event.dataset.quantity
        }]
      },

      success: addToCartOk,
      error: addToCartFail
    });
  },
  onUnload: function onUnload() {
    this.productForm.destroy();
    this.removeEventListener('click', this.onThumbnailClick);
    this.removeEventListener('keyup', this.onThumbnailKeyup);
  },
  getProductJson: function getProductJson(handle) {
    return fetch('/products/' + handle + '.js').then(function (response) {
      return response.json();
    });
  },
  onFormOptionChange: function onFormOptionChange(event) {
    var variant = event.dataset.variant;

    this.renderImages(variant);
    this.renderPrice(variant);
    this.renderComparePrice(variant);
    this.renderSubmitButton(variant);

    this.updateBrowserHistory(variant);
  },
  onThumbnailClick: function onThumbnailClick(event) {
    var thumbnail = event.target.closest(selectors.thumbnail);

    if (!thumbnail) {
      return;
    }

    event.preventDefault();

    //this.renderFeaturedImage(thumbnail.dataset.thumbnailId);
    this.renderActiveThumbnail(thumbnail.dataset.thumbnailId);
  },
  onThumbnailKeyup: function onThumbnailKeyup(event) {
    if (event.keyCode !== keyboardKeys.ENTER || !event.target.closest(selectors.thumbnail)) {
      return;
    }

    var visibleFeaturedImageWrapper = this.container.querySelector(selectors.visibleImageWrapper);

    (0, _themeA11y.forceFocus)(visibleFeaturedImageWrapper);
  },
  renderSubmitButton: function renderSubmitButton(variant) {
    var submitButton = this.container.querySelector(selectors.submitButton);
    var submitButtonText = this.container.querySelector(selectors.submitButtonText);

    if (!variant) {
      submitButton.disabled = true;
      submitButtonText.innerText = theme.strings.unavailable;
    } else if (variant.available) {
      submitButton.disabled = false;
      submitButtonText.innerText = theme.strings.addToCart;
    } else {
      submitButton.disabled = true;
      submitButtonText.innerText = theme.strings.soldOut;
    }
  },
  renderImages: function renderImages(variant) {
    if (!variant || variant.featured_image === null) {
      return;
    }

    //this.renderFeaturedImage(variant.featured_image.id);
    //this.renderActiveThumbnail(variant.featured_image.id);
  },
  renderPrice: function renderPrice(variant) {
    var priceElement = this.container.querySelector(selectors.productPrice);
    var priceWrapperElement = this.container.querySelector(selectors.priceWrapper);

    priceWrapperElement.classList.toggle(classes.hide, !variant);

    if (variant) {
      priceElement.innerText = (0, _themeCurrency.formatMoney)(variant.price, theme.moneyFormat);
    }
  },
  renderComparePrice: function renderComparePrice(variant) {
    if (!variant) {
      return;
    }

    var comparePriceElement = this.container.querySelector(selectors.comparePrice);
    var compareTextElement = this.container.querySelector(selectors.comparePriceText);

    if (!comparePriceElement || !compareTextElement) {
      return;
    }

    if (variant.compare_at_price > variant.price) {
      comparePriceElement.innerText = (0, _themeCurrency.formatMoney)(variant.compare_at_price, theme.moneyFormat);
      compareTextElement.classList.remove(classes.hide);
      comparePriceElement.classList.remove(classes.hide);
    } else {
      comparePriceElement.innerText = '';
      compareTextElement.classList.add(classes.hide);
      comparePriceElement.classList.add(classes.hide);
    }
  },
  renderActiveThumbnail: function renderActiveThumbnail(id) {
    var activeThumbnail = this.container.querySelector(selectors.thumbnailById(id));
    var inactiveThumbnail = this.container.querySelector(selectors.thumbnailActive);

    if (activeThumbnail === inactiveThumbnail) {
      return;
    }

    inactiveThumbnail.removeAttribute('aria-current');
    activeThumbnail.setAttribute('aria-current', true);
  },
  renderFeaturedImage: function renderFeaturedImage(id) {
    var activeImage = this.container.querySelector(selectors.visibleImageWrapper);
    var inactiveImage = this.container.querySelector(selectors.imageWrapperById(id));

    activeImage.classList.add(classes.hide);
    inactiveImage.classList.remove(classes.hide);
  },
  updateBrowserHistory: function updateBrowserHistory(variant) {
    var enableHistoryState = this.productForm.element.dataset.enableHistoryState;

    if (!variant || enableHistoryState !== 'true') {
      return;
    }

    var url = (0, _themeProductForm.getUrlWithVariant)(window.location.href, variant.id);
    window.history.replaceState({ path: url }, '', url);
  }
});